'use client';
import { Dispatch, SetStateAction, useEffect } from 'react';
import { WorkingHours } from '@/components';
import { getAggregatedSchedule, getTodaySchedule } from '@/api/medicalUnits/medicalUnits';
import { SchedulesData } from '@/components/pages/contacts/ContactsPage/Schedules/Schedules.types';
import styles from '../ContactsGrid/ContactsGrid.module.scss';
import s from './Schedules.module.scss';

interface Props {
  schedules?: SchedulesData;
  setSchedules: Dispatch<SetStateAction<SchedulesData | undefined>>;
}

export const Schedules = ({ schedules, setSchedules }: Props) => {

  useEffect(() => {
    if (schedules) return;

    Promise.all([
      getAggregatedSchedule({ id: 1 }),
      getAggregatedSchedule({ id: 2 }),
      getTodaySchedule({ id: 1 }),
      getTodaySchedule({ id: 2 }),
    ])
      .then((
        [
          aggregatedClinicSchedule,
          aggregatedPharmacySchedule,
          todayClinicSchedule,
          todayPharmacySchedule,
        ],
      ) => {
        setSchedules({
          aggregatedClinicSchedule,
          aggregatedPharmacySchedule,
          todayClinicSchedule,
          todayPharmacySchedule,
        });
      })
      .catch(console.error);
  }, []);

  if (!schedules) return null;

  return (
    <div className={s.wrapper}>
      <div className={styles.grid__card}>
        <WorkingHours
          openTime={schedules.todayClinicSchedule.open_time}
          closeTime={schedules.todayClinicSchedule.close_time}
          aggregatedSchedule={schedules.aggregatedClinicSchedule}
          title="График работы клиники"
        />
      </div>

      <div className={styles.grid__card}>
        <WorkingHours
          openTime={schedules.todayPharmacySchedule.open_time}
          closeTime={schedules.todayPharmacySchedule.close_time}
          aggregatedSchedule={schedules.aggregatedPharmacySchedule}
          title="График работы аптеки"
        />
      </div>
    </div>
  );
};